import React from "react";
import "./DashboardProfileAvatar.css";

const DashboardProfileAvatar = ({ image, name, onClick }) => {
  const firstName = String(name || "Student").trim().split(/\s+/)[0];
  const initial = firstName.charAt(0).toUpperCase();

  return (
    <button
      type="button"
      className="dashboard-profile-avatar"
      aria-label="Profile"
      onClick={onClick}
    >
      {image ? (
        <img
          src={image}
          alt={name || "Profile"}
          className="dashboard-profile-avatar__image"
        />
      ) : (
        <span className="dashboard-profile-avatar__fallback">{initial}</span>
      )}
    </button>
  );
};

export default DashboardProfileAvatar;
